import React, { useMemo } from 'react'
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min'
import { GridNode } from '../common/shared/grid-item'
import { CourseMenu } from '../common/menu/node-actions'
import { IconCourse } from '../../../../../shared/icon/icon'
import { useIsHD } from '../common/shared/metadata'
import { PlatformIcons } from '../common/platform/platform-controls'
import { NodeUpdated } from '../common/shared/node-updated'

export const NodeContentGridItem = ({ node, dataContext }) => {
  const { url } = useRouteMatch()

  const to = useMemo(() => `${url}/course/${node.id}`, [url, node])

  // const tags = useTags(node)
  const isHD = useIsHD(node)

  const FooterMenu = () => <CourseMenu place="card" url={`${url}/course/${node.id}`} node={node} nodeID={node.id} />
  // Where the course runs (content's `platforms` on each listed node). The
  // same component from render to render, so its list stays open while the
  // grid's thumbnails arrive.
  const platforms = node.platforms
  const Badges = useMemo(() => () => <PlatformIcons platforms={platforms} unpublished card />, [platforms])
  // When a build of it last became available, else when it was created.
  const Detail = () => <NodeUpdated node={node} />

  return (
    <GridNode Icon={IconCourse} FooterMenu={FooterMenu} Badges={Badges} Detail={Detail} Overlay1={isHD ? HDOverlay : React.Fragment} node={node} to={to} dataContext={dataContext} />
  )
}

const HDOverlay = () => {
  return (
    <div
      className="hdBackground"
      style={{
        position: 'absolute',
        bottom: '5px',
        right: '8px',
        opacity: '90%'
      }}>
      {/* <IconHD size="lg" /> */}
      <span className="m-1 fw-bold text-light-emphasis">URP</span>
    </div>
  )
}
